export const GET_QUOTE_SUCCESS = 'quotes/GET_QUOTE_SUCCESS';
export const EDIT_COMMISSION_SPLIT_SUCCESS = 'quotes/EDIT_COMMISSION_SPLIT_SUCCESS';
export const GET_QUOTES = 'quotes/GET_QUOTES';
export const SET_PLAN_TYPE = 'quote/SET_PLAN_TYPE';
export const CREATE_NEW_PLAN_DESIGN = 'quote/CREATE_NEW_PLAN_DESIGN';
export const SAVE_PLAN_DESIGN_BENEFIT_INIT_DATA = 'quote/SAVE_PLAN_DESIGN_BENEFIT_INIT_DATA';
export const SAVE_PLAN_DESIGN_FIELD = 'quote/SAVE_PLAN_DESIGN_FIELD';
export const REVERT_FROM_REVISION = 'quote/REVERT_FROM_REVISION';
export const SAVE_MODULAR_BENEFIT_INIT_DATA = 'quote/SAVE_MODULAR_BENEFIT_INIT_DATA';
export const SAVE_MODULAR_FIELD = 'quote/SAVE_MODULAR_FIELD';
export const SET_STATE = 'quote/SET_STATE';
export const GET_QUOTES_FOR_REVIEW = 'quote/GET_QUOTES_FOR_REVIEW';
export const SAVE_PRICING_INPUT = 'quote/SAVE_PRICING_INPUT';
export const SAVE_TELUS_DRUG_PLAN_ID = 'quote/SAVE_TELUS_DRUG_PLAN_ID';
export const ADD_CLASS_SUCCESS = 'quote/ADD_CLASS_SUCCESS';
export const EDIT_CLASS_SUCCESS = 'quote/EDIT_CLASS_SUCCESS';
export const ADD_DIVISION_SUCCESS = 'quote/ADD_DIVISION_SUCCESS';
export const EDIT_DIVISION_SUCCESS = 'quote/EDIT_DIVISION_SUCCESS';
export const SAVE_CLASS_COVERAGES = 'quote/SAVE_CLASS_COVERAGES';
export const SAVE_COMMISSIONS = 'quote/SAVE_COMMISSIONS';
export const ADD_DESIGN_FOR_NEW_CLASS = 'quote/ADD_DESIGN_FOR_NEW_CLASS';
export const REMOVE_CLASS_SUCCESS = 'quote/REMOVE_CLASS_SUCCESS';
export const REMOVE_DIVISION_SUCCESS = 'quote/REMOVE_DIVISION_SUCCESS';